module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Muenchenstein-9db9845c977b2d766037061f251cee15.png";